import { graphConfig } from "./authConfig";

/**
 * 
 * @param accessToken 
 */
export async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
  headers.append("Access-Control-Allow-Origin", "*");

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}
